import React from 'react';
import './FloatingLabelSelect.css';

const FloatingLabelSelect = ({ name, label, value, onChange, options = [], valueKey = 'id' }) => {
  const isFilled = options; // Check if the field has a valid value


  return (
    <div className={`floating-label-select ${isFilled ? 'filled' : ''}`}>
      <select
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        required
      >
        <option value="Label" disabled hidden></option> {/* Placeholder */}
        {options.map((opt) => (
          <option key={opt[valueKey]} value={opt[valueKey]}>
            {opt.name} {/* Always display name as text */}
          </option>
        ))}
      </select>
      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export default FloatingLabelSelect;
